export const METRICS_URL = 'resource/metric-url'
export const METRIC_TYPE = 'resource/metric-type'
export const METRIC_INSTANCE = 'resource/metric-instance'

// Resource metric types
export const RESOURCE_METRIC_TYPES = {
  ERROR_RATE: 'error_rate',
  QPS: 'qps',
  LATENCY_P99: 'latency_p99',
  LATENCY_P95: 'latency_p95',
  LATENCY_P50: 'latency_p50',
  
  // CPU Metrics (3 types)
  CPU_USAGE: 'cpu_usage',
  CPU_LOAD_1M: 'cpu_load_1m',
  CPU_CORES_USED: 'cpu_cores_used',
  
  // Memory Metrics (3 types)
  MEMORY_USAGE: 'memory_usage',
  MEMORY_AVAILABLE: 'memory_available',
  MEMORY_SWAP: 'memory_swap',
  
  // Disk Metrics (3 types)
  DISK_USAGE: 'disk_usage',
  DISK_IO_READ: 'disk_io_read',
  DISK_IO_WRITE: 'disk_io_write',
  
  // Network Metrics (3 types)
  NETWORK_IO: 'network_io',
  NETWORK_PACKETS: 'network_packets',
  NETWORK_ERRORS: 'network_errors'
} as const;

export type ResourceMetricType = typeof RESOURCE_METRIC_TYPES[keyof typeof RESOURCE_METRIC_TYPES];
